"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaleorManager = exports.createSaleorClient = void 0;
const apollo_client_1 = require("apollo-client");
const apollo_link_1 = require("apollo-link");
const apollo_link_batch_http_1 = require("apollo-link-batch-http");
const apollo_link_retry_1 = require("apollo-link-retry");
const api_1 = require("./api");
const APIProxy_1 = require("./api/APIProxy");
const getLink = (apiUrl, invalidTokenLink, authLink) => apollo_link_1.ApolloLink.from([
    invalidTokenLink,
    authLink,
    new apollo_link_retry_1.RetryLink(),
    new apollo_link_batch_http_1.BatchHttpLink({ uri: apiUrl }),
]);
function createSaleorClient(apiUrl, invalidTokenLink, authLink, cache) {
    return new apollo_client_1.ApolloClient({
        cache,
        link: getLink(apiUrl, invalidTokenLink, authLink),
    });
}
exports.createSaleorClient = createSaleorClient;
class SaleorManager {
    constructor(client, config) {
        this.onSaleorAPIChange = () => {
            if (this.apiChangeListener) {
                this.apiChangeListener(this.api);
            }
        };
        this.apiProxy = new APIProxy_1.APIProxy(client);
        this.api = new api_1.SaleorAPI(client, this.apiProxy, config, this.onSaleorAPIChange);
    }
    /**
     * Use this method to obtain current API and listen to its update on occured changes within it.
     * @param apiChangeListener Function called to get an API and called on every API update.
     */
    connect(apiChangeListener) {
        this.apiChangeListener = apiChangeListener;
        this.apiChangeListener(this.api);
    }
}
exports.SaleorManager = SaleorManager;
__exportStar(require("./auth"), exports);
__exportStar(require("./gqlTypes/globalTypes"), exports);
__exportStar(require("./react"), exports);
//# sourceMappingURL=index.js.map